import { useEffect } from 'react';
import { GridApi } from 'ag-grid-community';

export const useGridEvent = (api: GridApi | null, event: string, listener: (event: any) => void) => {
  useEffect(() => {
    if (!api) {
      return;
    }
    // @ts-expect-error AG Grid 34 event types are stricter but we allow any string event name
    api.addEventListener(event, listener);
    // @ts-expect-error AG Grid 34 event types are stricter but we allow any string event name
    return () => api.removeEventListener(event, listener);
  }, [api, event, listener]);
};

export const useDetailsGridsEvent = (api: GridApi | null, event: string, listener: (event: any) => void, deps: any[] = []) => {
  useEffect(() => {
    if (!api) {
      return;
    }

    api.forEachDetailGridInfo((gridDetailsInfo) => {
      // @ts-expect-error AG Grid 34 event types are stricter but we allow any string event name
      gridDetailsInfo.api.addEventListener(event, listener);
    });

    return () => {
      api.forEachDetailGridInfo((gridDetailsInfo) => {
        // @ts-expect-error AG Grid 34 event types are stricter but we allow any string event name
        gridDetailsInfo.api.removeEventListener(event, listener);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, event, listener, ...deps]);
};
